import { useQuery } from 'apollo-client'
import { constants } from 'helpers'
import { useFt } from 'hooks'

import featuredBrandPodcastsQuery from './graph/featuredBrandPodcasts.strapi.graphql'


type BrandPodcastsProps = {
  slug: string
}

const useBrandPodcasts = ({ slug }: BrandPodcastsProps) => {
  const isScentbirdPodcastEntryPointsEnabled = useFt(constants.features.scentbirdPodcastEntryPoints)

  const { data, isFetching } = useQuery(featuredBrandPodcastsQuery, {
    client: 'strapi',
    skip: !isScentbirdPodcastEntryPointsEnabled,
    variables: {
      input: {
        slug: {
          eq: slug,
        },
      },
    },
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    context: {
      ssrCache: true,
    },
  })

  const podcasts = data?.featuredBrands?.data?.[0]?.attributes?.podcastsSection?.data?.[0]?.attributes?.banner

  return {
    isFetching,
    data: podcasts,
  }
}

export default useBrandPodcasts
